import React from 'react';
import {hot} from 'react-hot-loader';
import {ApolloProvider} from 'react-apollo';
import {Provider} from 'react-redux';
import {BrowserRouter, Route} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import {ExperimentProvider} from '@homeaway/react-experiment';
import {LocalizationContextProvider} from '@homeaway/react-localization-components';
import App from './components/App/App';
import {EdapProvider} from '@homeaway/react-event-tracking';
import {VrbexProvider} from './components/context/VrbexContext';

class Root extends React.Component {
    static defaultProps = {
        abacus: {},
        client: {},
        helmetContext: {},
        store: {},
        isVrbex: false,
        isVrbexNative: false,
        isConfirmationToTID: false,
    };

    render() {
        return (
            <HelmetProvider context={this.props.helmetContext}>
                <ApolloProvider client={this.props.client}>
                    <Provider store={this.props.store}>
                        <ExperimentProvider abacus={this.props.abacus}>
                            <EdapProvider>
                                <LocalizationContextProvider
                                    siteContext={this.props.siteContext}
                                >
                                    <VrbexProvider
                                        value={{
                                            isVrbex: this.props.isVrbex,
                                            isVrbexNative:
                                                this.props.isVrbexNative,
                                            isConfirmationToTID:
                                                this.props.isConfirmationToTID,
                                        }}
                                    >
                                        <BrowserRouter
                                            basename={
                                                this.props.siteContext.basePath
                                            }
                                        >
                                            <Route
                                                path="/traveler/th/*"
                                                component={App}
                                            />
                                        </BrowserRouter>
                                    </VrbexProvider>
                                </LocalizationContextProvider>
                            </EdapProvider>
                        </ExperimentProvider>
                    </Provider>
                </ApolloProvider>
            </HelmetProvider>
        );
    }
}

export default hot(module)(Root);
